<template>
<div>
  <router-view v-if="this.$route.path!=='/accountManage/putInAccountManage' && this.$route.path!=='/qianchuan/account/qcputInAccount'"></router-view>
  <div v-else class="putInAccountManage">
   <div class="project_null" v-if="nullShow">
      <img class="" src="@/assets/img/project_manage_null.png" alt="">
      <div class="project_title">欢迎使用道有道智投RPA</div>
      <div  class="project_sub">通过投放账户管理可以集中管理各媒体广告投放平台绑定项目</div>
      <el-button type="primary" round>绑定头条广告投放平台账户</el-button>
    </div>
    <div v-else>
    <!-- 授权回调 -->
    <div class="authAccount" v-if="authAccountVisible">
      <el-dialog title="账户授权" :visible.sync="authAccountVisible">
        <el-form>
          <el-form-item>
              <p>请您在新打开的页面进行授权</p>
          </el-form-item>
          <el-form-item class="btn">
            <el-button size="small" type="primary" @click="authAccountSubmit">已完成授权</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
      <!-- 批量分配/分配项目 -->
      <div class="operationItem" v-if="operationItemVisible">
        <el-dialog :title="operationItemTitle" :visible.sync="operationItemVisible" :close-on-click-modal="false">
          <el-form ref="operationItemForm" :model="operationItemForm" :rules="operationItemRules">
            <el-form-item label="" prop="project">
              <el-select v-model="operationItemForm.project" placeholder="请选择所属项目">
                <el-option v-for="item in operationItemList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="btn">
              <el-button size="small" @click="operationItemVisible=false">取 消</el-button>
              <el-button size="small" type="primary" @click="operationItemSubmit('operationItemForm')" :loading="operationLoading" v-permission="'account:project:update'">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 优化师 -->
      <div class="operationItem" v-if="assignOptimizVisible">
        <el-dialog title="分配优化师" :visible.sync="assignOptimizVisible" :close-on-click-modal="false">
          <el-form ref="assignOptimizForm" :model="assignOptimizForm" :rules="assignOptimizRules">
            <el-form-item label="" prop="id">
              <el-select v-model="assignOptimizForm.id" placeholder="请选择所属优化师">
                <el-option v-for="item in optimizerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="btn">
              <el-button size="small" @click="assignOptimizVisible=false">取 消</el-button>
              <el-button size="small" type="primary" v-permission="'account:exclusive:update'" :loading="operationLoading" @click="assignEmployeesSubmit('assignOptimizForm',assignOptimizerId)">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 共享优化师 -->
      <div class="assignEmployees" v-if="assignEmployeesVisible">
        <el-dialog title="分配共享优化师" :visible.sync="assignEmployeesVisible" :close-on-click-modal="false">
          <el-form ref="assignEmployeesForm" :model="assignEmployeesForm" :rules="assignEmployeesRules">
            <el-form-item label="" prop="list">
              <el-transfer
                v-loading="assignOptimizerLoading"
                v-model="assignEmployeesForm.list"
                filterable
                :titles="['未选择', '已选择']"
                :format="{
                  noChecked: '0/${total}',
                  hasChecked: '${checked}/${total}'
                }"
                @left-check-change="transferLeftChange"
                @change="handleChange"
                :data="sharedOptimizingList">
              </el-transfer>
            </el-form-item>
            <el-form-item class="btn">
              <el-button size="small" @click="assignEmployeesVisible=false">取 消</el-button>
              <el-button size="small" type="primary" @click="assignEmployeesSubmit('assignEmployeesForm',assignOptimizerId)" v-permission="'account:employee:update'">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 代理商-->
      <div class="operationItem" v-if="operationAgentVisible">
        <el-dialog :title="operationAgentTitle" :visible.sync="operationAgentVisible" :close-on-click-modal="false">
          <el-form ref="operationAgentForm" :model="operationAgentForm" :rules="operationAgentRules">
            <el-form-item label="" prop="id">
              <el-select v-model="operationAgentForm.id" placeholder="请选择代理商">
                <el-option v-for="item in agentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="btn">
              <el-button size="small" @click="operationAgentVisible=false">取 消</el-button>
              <el-button size="small" type="primary" @click="operationAgentSubmit('operationAgentForm',operationAgentId)" v-permission="'account:agency:update'">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 同步数据 -->
      <div class="syncData" v-if="syncDataVisible">
        <el-dialog :title="syncDataTitle" :visible.sync="syncDataVisible" :close-on-click-modal="false">
          <el-form ref="syncDataForm" :model="syncDataForm" :rules="syncDataRules">
            <el-form-item label="" prop="filterDate">
              <el-date-picker
                v-model="syncDataForm.filterDate"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <!-- v-if="syncDataTitle === '同步飞鱼数据'" -->
            <el-form-item label="是否自动同步线索开关" prop="optClue" v-if="syncDataTitle === '同步飞鱼数据'">
              <div class="joinType">
              <el-radio v-model="syncDataForm.optClue" :label="1">是</el-radio>
              <el-radio v-model="syncDataForm.optClue" :label="0" style="margit-left: 1px">否</el-radio>
              </div>
            </el-form-item>
            <el-form-item class="btn">
              <el-button size="small" @click="syncDataVisible=false">取 消</el-button>
              <el-button size="small" type="primary" @click="syncDataSubmit('syncDataForm',syncDataId)" :loading="btnLoading">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <div class="putInAccountManageCon">
          <div class="top clearFix">
            <div class="page-title">投放账户管理</div>
            <!-- isQianchuan() -->
            <el-tabs v-if="!isQianchuan && starPermission" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="AD账户授权" name="juliang"></el-tab-pane>
              <el-tab-pane label="星图账户授权" name="star"><star-auth v-if="activeName === 'star'" ref="starAuthRef" @getOeAuthUrl="getOeAuthUrl"></star-auth></el-tab-pane>
            </el-tabs>
            <div v-show="activeName === 'juliang' || isQianchuan">
              <div class="form">
                <el-form :inline="true" label-width="120px">
                  <!-- <div> -->
                  <el-form-item label="所属产品">
                    <el-select v-model="filterParam.productId" placeholder="请选择所属产品">
                      <el-option v-for="item in productList" :key="item.id" :label="item.productName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="所属项目">
                    <el-select v-model="filterParam.projectId" filterable clearable placeholder="请选择所属项目">
                      <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="账户状态">
                    <el-select v-model="filterParam.status" @change="getputInAccountManageList()" filterable clearable placeholder="请选择账户状态">
                      <el-option label="正常投放" value="1"></el-option>
                      <el-option label="暂停投放" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="授权状态">
                    <el-select v-model="filterParam.isVaild" @change="getputInAccountManageList()" filterable clearable placeholder="请选择授权状态">
                      <el-option label="正常" value="1"></el-option>
                      <el-option label="已失效" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- </div> -->
                  <!-- <div class="clear"></div> -->
                  <el-form-item label="广告投放账户/ID">
                    <el-input v-model="filterParam.agentAccountName" @blur="getputInAccountManageList()" placeholder="请输入广告投放账户或ID"></el-input>
                  </el-form-item>
                  <el-form-item label="优化师姓名">
                    <el-input v-model="filterParam.employeeName" @blur="getputInAccountManageList()" placeholder="请输入优化师姓名"></el-input>
                    <div class="searchBtn">
                      <el-button @click="getputInAccountManageList()"><i class="iconfont icon-sousuo"></i></el-button>
                    </div>
                  </el-form-item>
                  <div class="btn clearfix">
                    <el-dropdown @command="handleCommand">
                      <el-button size="medium" class="white" type="primary" :disabled='batchDisabled' v-permission="'account:project:list'">
                        批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown" class="dropdownMenuCenter">
                        <el-dropdown-item command="project" v-permission="'account:project:list'" :disabled="listSelectionStatus">分配项目</el-dropdown-item>
                        <el-dropdown-item command="put" v-permission="'account:data:sync:oe:item'" :disabled="listSelectionStatus">同步投放</el-dropdown-item>
                        <el-dropdown-item command="data" v-permission="'account:data:sync:oe:report'" :disabled="listSelectionStatus">同步数据</el-dropdown-item>
                        <el-dropdown-item command="materialAuthData" v-permission="'account:data:sync:oe:feiyuClue'" :disabled="listSelectionStatus" v-if="!isQianchuan">同步飞鱼线索</el-dropdown-item>
                        <el-dropdown-item command="optimizer" v-permission="'account:exclusive:update'" :disabled="listSelectionStatus">修改优化师</el-dropdown-item>
                        <el-dropdown-item command="sharedOptimizer" v-permission="'account:employee:update'" :disabled="listSelectionStatus">修改共享优化师</el-dropdown-item>
                        <el-dropdown-item command="agent" v-permission="'account:agency:update'" :disabled="listSelectionStatus">修改代理商</el-dropdown-item>
                        <el-dropdown-item command="openAccount">开启账户</el-dropdown-item>
                        <el-dropdown-item command="closeAccount">关闭账户</el-dropdown-item>
                        <el-dropdown-item command="openMaterialAuth" :disabled="listSelectionStatus">开启敏感物料授权</el-dropdown-item>
                        <el-dropdown-item command="closeMaterialAuth" :disabled="listSelectionStatus">关闭敏感物料授权</el-dropdown-item>
                        <el-dropdown-item command="delAccount">删除账户</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <!--  @click="parseInt(sessionStorage.getItem('isIntro'))?'':getOeAuthUrl" id="guide-step3" -->
                    <el-button type="primary" size="medium" icon="" @click="getOeAuthUrl" v-permission="'account:employee:getOeAuthUrl'"><i class="iconfont icon-tianjia-copy"></i>广告投放账户</el-button>
                    <div class="materialAuth" v-permission="'account:sensitiveStatus:update'">
                      <el-checkbox v-model="materialAuth">敏感物料授权</el-checkbox>
                      <el-popover
                        v-if="!isQianchuan"
                        popper-class="popper-problem"
                        placement="right"
                        width="200"
                        trigger="hover"
                        content="勾选后可同步飞鱼线索数据">
                        <i slot="reference" class="iconfont icon-wenhao"></i>
                      </el-popover>
                    </div>
                  </div>
                </el-form>
              </div>
              <div class="tableBox">
                <el-table ref="table" class="roleTable" :max-height="tabheight" :data="putInAccountManageList" border @selection-change="handleSelectionChange">
                  <el-table-column type="selection" width="50" v-if="pageTotal>0"></el-table-column>
                  <!--  :selectable='selectEnable' -->
                  <el-table-column prop="agentAccountId" label="账户ID"  min-width="154"></el-table-column>
                  <el-table-column prop="agentBalance" label="账户总余额"  min-width="100"></el-table-column>
                  <el-table-column prop="agentAccountName" label="广告投放账户" fixed min-width="200"></el-table-column>
                  <el-table-column label="产品/项目" width="150">
                    <template slot="header" class="tool">
                      <span>产品/项目</span>
                      <el-tooltip effect="light" placement="right" popper-class="atooltip">
                        <div slot="content">项目隶属于产品</div>
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <el-tooltip v-if="scope.row.projectName==undefined" content="分配" placement="top" v-permission="'account:project:update'">
                        <span v-if="scope.row.status" @click="operationItem('null','',scope.row.id)" class="red">未分配 / 未分配</span>
                        <span v-else>未分配 / 未分配</span>
                      </el-tooltip>
                      <div v-else class="projectBox">
                        <span>
                          {{scope.row.productName}} / {{scope.row.projectName}}
                          <el-tooltip content="编辑" placement="top" v-permission="'account:project:update'" v-if="scope.row.status">
                            <i @click="operationItem('edit',scope.row.projectId,scope.row.id)" class="iconfont icon-edit"></i>
                          </el-tooltip>
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="优化师" min-width="140">
                    <template slot="header" class="tool">
                      <span>优化师</span>
                      <el-tooltip effect="light" placement="right" popper-class="atooltip">
                        <div slot="content">一个投放账户专属于一个优化师，拥有账户所有权限</div>
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <div v-if="scope.row.status">
                        <el-tooltip content="分配" placement="top" v-if="scope.row.optimizing==''||scope.row.optimizing==undefined" v-permission="'account:exclusive:update'">
                            <span class="red" @click="assignEmployees(false,scope.row.id,scope.row.optimizing)">未分配</span>
                        </el-tooltip>
                        <div class="edit" v-else>
                          {{scope.row.optimizing}}
                          <el-tooltip content="编辑" placement="top" v-permission="'account:exclusive:update'">
                            <i @click="assignEmployees(false,scope.row.id,scope.row.optimizing)" class="iconfont icon-edit"></i>
                          </el-tooltip>
                        </div>
                      </div>
                      <div v-else>
                        <span v-if="scope.row.optimizing==undefined">未分配</span>
                        <div class="edit" v-else>
                          {{scope.row.optimizing}}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="共享优化师" min-width="140">
                    <template slot="header" class="tool">
                      <span>共享优化师</span>
                      <el-tooltip effect="light" placement="right" popper-class="atooltip">
                        <div slot="content">只可查看账户相关报表，不可操作投放</div>
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <div v-if="scope.row.employees==''||scope.row.employees==undefined">
                        <el-tooltip content="分配" placement="top" v-if="scope.row.status" v-permission="'account:employee:update'">
                            <span class="red pointer" @click="assignEmployees(false,scope.row.id,'shared')">未分配</span>
                        </el-tooltip>
                        <span v-else>未分配</span>
                      </div>
                      <div class="edit" v-else>
                        {{scope.row.employees}}
                        <el-tooltip content="编辑" placement="top" v-permission="'account:employee:update'" v-if="scope.row.status">
                          <i @click="assignEmployees(false,scope.row.id,'shared')" class="iconfont icon-edit"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="同步状态" min-width="200">
                    <template slot-scope="scope">
                      <span :class="{'red':scope.row.syncStatus=='投放未同步','blue':scope.row.syncStatus=='投放同步中','green':scope.row.syncStatus=='投放已同步'}">{{scope.row.syncStatus}} /</span>
                      <span :class="{'red':scope.row.syncDataStatus=='数据未同步','blue':scope.row.syncDataStatus=='数据同步中','green':scope.row.syncDataStatus=='数据已同步'}">{{scope.row.syncDataStatus}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" min-width="200" fixed='right' v-if="checkPermission('account:data:sync:oe:item') || checkPermission('account:data:sync:oe:report') || checkPermission('account:data:sync:oe:feiyuClue')">
                    <template slot-scope="scope">
                      <!-- v-if="scope.row.syncDataStatus!=='数据已同步'" -->
                      <span type="text">同步:&nbsp;</span>
                      <el-button size="small" :disabled="!scope.row.status" @click="syncPut('',scope.row.id)" type="text" v-permission="'account:data:sync:oe:item'">投放</el-button>
                      <el-button size="small" :disabled="!scope.row.status" @click="syncData(false,'syncAccountData',scope.row.id)" type="text" v-permission="'account:data:sync:oe:report'">数据</el-button>
                      <el-button v-if="!isQianchuan" size="small" :disabled="!scope.row.status" @click="syncData(false,'syncMaterialAuth',scope.row.id, scope.row)" type="text" v-permission="'account:data:sync:oe:feiyuClue'">飞鱼线索</el-button>
                      <!-- <span v-else>同步完成</span> -->
                    </template>
                  </el-table-column>
                  <el-table-column label="所属代理商" min-width="120">
                    <template slot-scope="scope">
                      <div v-if="scope.row.status">
                        <el-tooltip content="分配" placement="top" v-if="scope.row.agencyName==''||scope.row.agencyName==undefined" v-permission="'account:employee:list'">
                            <span class="red pointer" @click="operationAgent(false,scope.row.id,scope.row.agencyName)">未分配</span>
                        </el-tooltip>
                        <div class="edit" v-else>
                          {{scope.row.agencyName}}
                          <!-- v-permission="'account:employee:list'" -->
                          <el-tooltip content="编辑" placement="top" v-permission="'account:agency:update'">
                            <i  @click="operationAgent(false,scope.row.id,scope.row.agencyName)" class="iconfont icon-edit"></i>
                          </el-tooltip>
                        </div>
                      </div>
                      <div v-else>
                        <span v-if="scope.row.agencyName==''||scope.row.agencyName==undefined">未分配</span>
                        <div class="edit" v-else>
                          {{scope.row.agencyName}}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="敏感物料" min-width="100" fixed='right'>
                    <template slot-scope="scope">
                      <div class="green-round" v-if="scope.row.sensitiveStatus"></div>
                      <div class="red-round" v-else></div>
                      <span>{{scope.row.sensitiveStatus ? '已授权' : '未授权'}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="账户状态" min-width="90" fixed='right'>
                    <template slot-scope="scope">
                      <el-switch @change="accountStatusChange(scope.row,scope.row.id,'status')" v-model="scope.row.status" :disabled="!checkPermission('account:status:update')"></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column label="授权状态" min-width="80" fixed='right'>
                    <template slot-scope="scope">
                      <span v-if="scope.row.isVaild === 0">已失效</span>
                      <span v-else-if="scope.row.isVaild === 1">正常</span>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="paging-box" v-if="pageTotal>0">
                  <!-- <span class="page-total">显示全部项目{{pageTotal}}个项目</span> -->
                  <el-pagination background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[ 10, 20, 40, 80, 100]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// 表单验证
import { dateValidation, notNullable } from '@/components/form/formValidation'
import starAuth from './starAuth'
// 公用
import { getTime, handleTimeMonthsAgo } from '@/components/public'
export default {
  name: 'putInAccountManage',
  components: {starAuth},
  data () {
    // const generateData = _ => {
    //   const data = []
    //   for (let i = 1; i <= 15; i++) {
    //     data.push({
    //       key: i,
    //       label: '优化师' + i,
    //       disabled: i % 4 === 0
    //     })
    //   }
    //   return data
    // }
    return {
      btnLoading: false,
      starPermission: false,
      activeName: 'juliang',
      tabheight: null,
      nullShow: false,
      // 分页相关
      currentPage: 1, // 初始当前显示页
      pagesize: 10, // 初始每页的数据条数
      pageTotal: 0, // 数据总条数
      // 项目列表
      projectList: [],
      // 产品列表
      productList: [],
      // 分配/修改下拉框list
      operationItemList: [],
      // table
      listSelection: [],
      listSelectionStatus: true,
      putInAccountManageList: [],
      putInAccountManageParam: {},
      // 筛选参数
      filterParam: {
        agentAccountName: '',
        employeeName: '',
        productId: '',
        projectId: '',
        status: '',
        isVaild: ''
      },
      // 分配/修改项目
      operationItemTitle: '',
      operationItemVisible: false,
      operationLoading: false,
      operationItemId: [],
      operationItemForm: {
        project: ''
      },
      operationItemRules: {
        project: [
          notNullable('请选择所属项目')
        ]
      },
      // 优化师
      assignOptimizVisible: false,
      assignOptimizForm: {
        id: ''
      },
      assignOptimizRules: {
        id: [
          notNullable('请选择要分配的优化师')
        ]
      },
      optimizerList: [],
      // 共享优化师
      assignEmployeesVisible: false,
      assignOptimizerLoading: true,
      assignOptimizerId: [],
      assignOptimizerIdType: '',
      assignEmployeesForm: {
        list: []
      },
      assignEmployeesRules: {
        list: [
          notNullable('请选择要分配的优化师')
        ]
      },
      // 共享优化师列表
      sharedOptimizingList: [],
      // 代理商
      agentList: [],
      operationAgentId: [],
      operationAgentTitle: '',
      operationAgentVisible: false,
      operationAgentForm: {
        id: ''
      },
      operationAgentRules: {
        id: [
          notNullable('请选择要修改的代理商')
        ]
      },
      // 投放账户授权
      authAccountVisible: false,
      batchDisabled: true,
      // 敏感物料授权
      materialAuth: false,
      // 同步投放
      syncPutVisible: false,
      syncPutId: [],
      syncPutForm: {
        status: ''
      },
      syncPutRules: {
        status: [
          notNullable('请选择要同步的广告组状态')
        ]
      },
      // 同步数据
      syncDataVisible: false,
      syncDataTitle: '',
      syncDataType: '',
      syncDataId: [],
      syncDataForm: {
        optClue: 0,
        // filterDate: [handleTimeOld(new Date(), 'day'), handleTimeNew(new Date(), 'day')]
        filterDate: []
      },
      syncDataRules: {
        filterDate: [
          dateValidation('请选择您要同步数据的日期')
        ]
      },
      pickerOptions: {},
      domain: this.$service.prototype.$protocol + '://' + this.$service.prototype.$callBackHost
    }
  },
  created () {
    console.log('acc created')
    let type = this.$route.query.type
    if (type) {
      this.activeName = type
    }
    this.getPageData(this.$route.path)
    this.starPermission = this.checkPermission('star')
  },
  mounted () {
    console.log('this.domain', this.domain)
    // 引导页
    // if (parseInt(sessionStorage.getItem('isIntro'))) {
    //   let i = setInterval(() => {
    //     this.$guide([
    //       {
    //         title: '账户授权',
    //         intro: '详情详情(3/7)',
    //         element: document.querySelector('#guide-step3')
    //       }
    //     ])
    //     clearInterval(i)
    //   }, 500)
    // }
  },
  watch: {
    // 监测弹窗
    operationItemVisible (to, form) {
      if (to === false) {
        // 清空表单
        this.resetForm('operationItemForm')
        this.operationItemForm.project = ''
      }
    },
    assignEmployeesVisible (to, form) {
      if (to === false) {
        this.resetForm('assignEmployeesForm')
        this.assignEmployeesForm.list = []
      }
    },
    syncPutVisible (to, form) {
      if (to === false) {
        this.resetForm('syncPutForm')
        this.syncPutForm.filterDate = ''
      }
    },
    syncDataVisible (to, form) {
      if (to === false) {
        this.syncDataForm.optClue = 0
        this.resetForm('syncDataForm')
        this.syncDataForm.status = ''
        this.pickerOptions = {}
        this.syncDataForm.filterDate = []
      }
    },
    authAccountVisible (to, form) {
      if (to === false) {
        if (this.activeName !== 'star') {
          this.getputInAccountManageList()
        }
      }
    },
    // 监测下拉框内容更新 更新投放账户列表
    'filterParam.productId': {
      deep: true,
      handler: function (newV, oldV) {
        console.log(newV)
        this.getputInAccountManageList()
      }
    },
    'filterParam.projectId': {
      deep: true,
      handler: function (newV, oldV) {
        console.log(newV)
        this.getputInAccountManageList()
      }
    },
    $route (to, old) {
      if (to.path !== old.path) {
        this.getPageData(to.path)
      }
    },
    listSelection (to, form) {
      if (to.length < 1) {
        this.batchDisabled = true
      } else {
        this.batchDisabled = false
      }
    }
  },
  methods: {
    handleClick() {
      if (this.activeName === 'star') {
      }
      // this.$route.query.type = this.activeName
      this.$router.push({name: 'putInAccountManage', query: {type: this.activeName}})
      console.log('handleClick', this.activeName)
    },
    updatetabheight() {
      if (!this.tabheight) {
        let height = document.documentElement.clientHeight
        let offsetTop = this.$refs.table.$el.getBoundingClientRect().top
        console.log('offsetTop', offsetTop)
        this.$nextTick(() => {
          this.tabheight = parseInt(height - offsetTop - 20)
        })
      }
    },
    // 判断路由
    getPageData (routePath) {
      // 获取token并分割
      if (routePath === '/accountManage/putInAccountManage' || routePath === '/qianchuan/account/qcputInAccount') {
        // 获取产品列表
        this.getProductList()
        // 获取项目列表
        if (this.checkPermission('account:project:query:list')) {
          this.getProjectList()
        }
        // 获取投放列表
        this.getputInAccountManageList()
      }
    },
    // 获取项目列表
    getProjectList () {
      this.$service.get('/api/account/project/query/list?platformType=' + localStorage.platformType).then(res => {
        if (res.result.length > 0) {
          this.projectList = [{
            'projectName': '请选择',
            'id': 0
          }]
          res.result.forEach((item, index) => {
            this.projectList[index + 1] = item
          })
        }
      }).catch(Err => {
      })
    },
    // 获取产品列表
    getProductList () {
      this.$service.get('/api/account/product/list?platformType=' + localStorage.platformType).then(res => {
        if (res.result.length > 0) {
          this.productList = [{
            'productName': '请选择',
            'id': 0
          }]
          res.result.forEach((item, index) => {
            this.productList[index + 1] = item
          })
        }
      }).catch(Err => {
      })
    },
    // 获取投放项目列表
    getputInAccountManageList () {
      this.putInAccountManageParam = {
        'agentAccountName': this.filterParam.agentAccountName,
        'employeeName': this.filterParam.employeeName,
        'pageNum': this.currentPage,
        'pageSize': this.pagesize,
        'productId': this.filterParam.productId,
        'projectId': this.filterParam.projectId,
        'status': this.filterParam.status,
        'isVaild': this.filterParam.isVaild,
        platformType: parseInt(localStorage.platformType)
      }
      this.$service.post('/api/account/list', this.putInAccountManageParam).then(res => {
        res.result.pageData.forEach((item, index) => {
          item.syncDataStatus = this.getSyncStatus(item.syncDataStatus, '数据')
          item.syncStatus = this.getSyncStatus(item.syncStatus, '投放')
          item.status === 0 ? item.status = false : item.status = true
          item.sensitiveStatus === 0 ? item.sensitiveStatus = false : item.sensitiveStatus = true
        })
        console.log(res.result.pageData)
        this.putInAccountManageList = res.result.pageData
        this.pageTotal = res.result.total
        if (this.putInAccountManageList.length > 4) {
          this.updatetabheight()
        } else {
          this.tabheight = null
        }
      }).catch(Err => {
        console.log(Err)
      })
    },
    // 是否启用选择框
    selectEnable(row, rowIndex) {
      if (!row.status) {
        return false
      } else {
        return true
      }
    },
    // 获取代理商列表
    getAgentsList (name) {
      this.$service.post('/api/account/agency/list', {platformType: parseInt(localStorage.platformType)}).then(res => {
        let list = []
        res.result.forEach((item, index) => {
          list[index] = {
            'id': item.id,
            'name': item.name
          }
          if (name === item.name) {
            this.operationAgentForm.id = item.id
          }
        })
        this.agentList = list
      }).catch(Err => {
      })
    },
    // 获取优化师列表
    getOptimizerList (id, name, type) {
      this.$service.get('/api/account/employee/optimizing/list?id=' + id).then(res => {
        console.log(res)
        let list = []
        if (type === 'shared') {
          // 共享优化师
          res.result.forEach((item, index) => {
            list[index] = {
              'key': item.employeeId,
              'label': item.employeeName
            }
          })
          this.sharedOptimizingList = list
          this.assignEmployeesForm.list = []
          this.assignOptimizerLoading = false
        } else {
          // 优化师
          res.result.forEach((item, index) => {
            list[index] = {
              'id': item.employeeId,
              'name': item.employeeName
            }
            if (name === item.employeeName) {
              this.assignOptimizForm.id = item.employeeId
            }
          })
          this.optimizerList = list
        }
      }).catch(Err => {
      })
    },
    // 获取未分配优化师列表
    getEmployeeList (id) {
      this.$service.get('/api/account/employee/undistributed/list?id=' + id).then(res => {
        let list = []
        res.result.forEach((item, index) => {
          if (item.status === 1) {
            item.status = true
          } else {
            item.status = false
          }
          list[index] = {
            'key': item.employeeId,
            'label': item.employeeName
            // 'disabled': item.status
          }
        })
        this.sharedOptimizingList = list
        this.assignOptimizerLoading = false
        console.log(this.sharedOptimizingList)
      }).catch(Err => {
      })
    },
    // 获取已分配优化师列表
    getEmployeeValue (id) {
      this.$service.get('/api/account/employee/list?id=' + id).then(res => {
        console.log(res.result)
        let list = []
        res.result.forEach((item, index) => {
          list[index] = item.employeeId
        })
        this.assignEmployeesForm.list = list
        // 获取未选中优化师列表
        this.getEmployeeList(id, list)
      }).catch(Err => {
      })
    },
    // 获取同步状态
    getSyncStatus (status, name) {
      if (status === 0) {
        return name + '未同步'
      } else if (status === 1) {
        return name + '同步中'
      } else if (status === 2) {
        return name + '已同步'
      }
    },
    // （批量）修改代理商
    operationAgent(batch, id, name) {
      this.getAgentsList(name)
      this.operationAgentId = []
      if (batch) {
        this.operationAgentTitle = '批量修改代理商'
        this.listSelection.forEach((item, index) => {
          this.operationAgentId[index] = item.id
        })
      } else {
        this.operationAgentTitle = '修改代理商'
        this.operationAgentId[0] = id
      }
      this.operationAgentVisible = true
    },
    // 修改代理商提交
    operationAgentSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$service.post('/api/account/agency/update', {
            'ids': this.operationAgentId,
            'agencyId': this.operationAgentForm.id
          }).then(res => {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.getputInAccountManageList()
            this.operationAgentVisible = false
          }).catch(Err => {
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 分配/修改项目/优化师/代理商
    operationItem (type, text, id) {
      // 下拉列表赋值
      let list = []
      this.projectList.forEach((item, index) => {
        list[index] = {
          'id': item.id,
          'name': item.projectName
        }
      })
      this.operationItemList = list
      this.operationItemId = []
      if (type === 'batch') { // 批量分配
        if (this.listSelection.length < 1) {
          this.$message({
            message: '请选择需要分配的项目',
            type: 'warning'
          })
        } else {
          // title赋值
          this.operationItemTitle = '批量分配项目'
          // id赋值，为提交做准备
          this.listSelection.forEach((item, index) => {
            this.operationItemId.push(item.id)
          })
          // 显示弹窗
          this.operationItemVisible = true
        }
      } else {
        // title赋值
        this.operationItemTitle = '分配项目'
        // 编辑赋值
        if (type === 'edit') {
          this.operationItemForm.project = text
        }
        // 显示弹窗
        this.operationItemVisible = true
        // id赋值，为提交做准备
        this.operationItemId.push(id)
      }
    },
    operationItemSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.operationLoading = true
          this.$service.post('/api/account/project/update', {
            'ids': this.operationItemId,
            'projectId': this.operationItemForm.project
          }).then(res => {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.getputInAccountManageList()
            this.operationItemVisible = false
            this.operationLoading = false
          }).catch(Err => {
            this.operationLoading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 分配优化师
    assignEmployees (batch, id, name) {
      this.assignOptimizerIdType = name
      this.assignOptimizerId = []
      if (batch === false) {
        // 分配优化师/共享优化师
        this.assignOptimizerId[0] = id
        if (name === 'shared') {
          this.getEmployeeValue(id)
          this.assignEmployeesVisible = true
        } else {
          this.getOptimizerList(id, name)
          this.assignOptimizVisible = true
        }
      } else {
        // 批量分配优化师/共享优化师
        this.listSelection.forEach((item, index) => {
          this.assignOptimizerId[index] = item.id
        })
        if (name === 'shared') {
          // 共享优化师
          this.getOptimizerList('', '', 'shared')
          this.assignEmployeesForm.list = []
          this.assignEmployeesVisible = true
        } else {
          // 优化师
          this.getOptimizerList('')
          this.assignOptimizForm.id = ''
          this.assignOptimizVisible = true
        }
      }
      console.log(this.assignOptimizerId)
    },
    // 分配优化师
    assignEmployeesSubmit (formName, ids) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.operationLoading = true
          if (this.assignOptimizerIdType === 'shared') {
            console.log('共享优化师')
            this.$service.post('/api/account/employee/update', {
              'employeeIds': this.assignEmployeesForm.list,
              'id': ids
            }).then(res => {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.getputInAccountManageList()
              this.assignEmployeesVisible = false
              this.operationLoading = false
            }).catch(Err => {
              this.operationLoading = false
            })
          } else {
            console.log('优化师')
            this.$service.post('/api/account/exclusive/update', {
              'employeeId': this.assignOptimizForm.id,
              'ids': ids
            }).then(res => {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.getputInAccountManageList()
              this.assignOptimizVisible = false
              this.operationLoading = false
            }).catch(Err => {
              this.operationLoading = false
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 添加广告投放账户
    // 获取用户授权地址
    getOeAuthUrl () {
      console.log('getOeAuthUrl')
      // 需要处理巨量跟千川地址
      let authCallback = '/accountManage/authCallback'
      let url = '/api/account/employee/getOeAuthUrl'
      if (this.isQianchuan) {
        url += '/qc'
        authCallback = '/qianchuan/account/authCallback'
        // this.domain = this.domain.replace('192.168.30.73:9909', '192.168.30.29:9909')
      }
      console.log(authCallback)
      let getOeAuthUrl = url
      if (this.materialAuth) {
        console.log('授权敏感物料')
        getOeAuthUrl += '?material_auth=1'
      } else {
        console.log('未授权敏感物料')
        getOeAuthUrl += '?material_auth=0'
      }
      // 不是千川，要加参数区分巨量还是星图
      if (!this.isQianchuan) {
        getOeAuthUrl += ('&platform=' + (this.activeName === 'star' ? 3 : 1))
      }
      // qianchuan/account/authCallback
      getOeAuthUrl += '&successPage=' + this.domain + authCallback
      console.log(getOeAuthUrl)
      this.$service.get(getOeAuthUrl).then(res => {
        // res.result.url = ''
        // https://ad.oceanengine.com/openapi/audit/oauth.html?app_id=1683698391920660&state=43&material_auth=0&redirect_uri=http://192.168.30.73:9909/accountManage/authCallback
        if (res.result.url === '' || res.result.url === undefined) {

        } else {
          // 跳转授权页面
          window.open(res.result.url, '_blank')
          // 显示确认弹窗
          this.authAccountVisible = true
        }
      }).catch(Err => {
      })
    },
    // 切换账号状态
    accountStatusChange(row, ids, type) {
      let accountStatus
      if (row.status !== undefined) {
        row.status ? accountStatus = 1 : accountStatus = 0
      } else {
        row ? accountStatus = 1 : accountStatus = 0
      }
      if (type === 'status') {
        // 暂停状态的账户不出现在任何有选择账户操作的地方。
        if (ids.length) {
          let statusTxt = accountStatus ? '开启' : '暂停'
          this.$confirm('是否操作批量' + statusTxt + '账户 ', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            this.changeAccountStatus(ids, accountStatus)
          }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消操作'
          // })
          })
        } else {
          console.log(row)
          this.changeAccountStatus([ids], accountStatus)
        }
      }
    },
    changeAccountStatus(ids, accountStatus) {
      this.$service.post('/api/account/status/update', {
        'id': ids,
        'status': accountStatus
      }).then(res => {
        this.$message.closeAll()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        // 刷新投放列表
        this.getputInAccountManageList()
      }).catch(Err => {
      })
    },
    changeSensitiveStatus(ids, status, changeAccountStatus) {
      if (ids.length) {
        if (!changeAccountStatus) {
          let statusTxt = status ? '开启' : '暂停'
          this.$confirm('是否操作批量' + statusTxt + '敏感物料授权', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            this.changeAccountSensitiveStatus(ids, status)
          }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消操作'
            // })
          })
        } else {
          this.changeAccountSensitiveStatus(ids, status)
        }
      } else {
        this.changeAccountSensitiveStatus([ids], status)
      }
    },
    changeAccountSensitiveStatus(ids, status) {
      this.$service.post('/api/account/sensitiveStatus/update', {
        'id': ids,
        'status': status
      }).then(res => {
        this.$message.closeAll()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        // 刷新投放列表
        this.getputInAccountManageList()
      }).catch(Err => {
      })
    },
    // 删除账户
    delAccount(ids) {
      console.log('delAccount', ids)
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.changeAccountStatus(ids, 2)
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消操作'
        // })
      })
    },
    authAccountSubmit () {
      this.authAccountVisible = false
      // 刷新投放列表
      // this.getputInAccountManageList()
      if (this.activeName === 'star') {
        const starAuth = this.$refs.starAuthRef
        if (starAuth) {
          starAuth.getTabList()
        }
      }
    },
    handleCommand (command) {
      let ids = []
      this.listSelection.forEach((item, index) => {
        ids.push(item.id)
      })
      if (command === 'project') {
        // 批量分配项目
        this.operationItem('batch')
      } else if (command === 'put') {
        // 批量同步投放
        this.syncPut('batch')
      } else if (command === 'data') {
        // 批量同步数据
        this.syncData(true, 'syncAccountData')
      } else if (command === 'materialAuthData') {
        // 批量同步飞鱼数据
        this.syncData(true, 'syncMaterialAuth')
      } else if (command === 'optimizer') {
        // 批量修改优化师
        this.assignEmployees(true)
      } else if (command === 'sharedOptimizer') {
        // 批量修改共享优化师
        this.assignEmployees(true, null, 'shared')
      } else if (command === 'agent') {
        // 批量修改代理商
        this.operationAgent(true)
      } else if (command === 'openAccount') {
        // 开启账户
        this.accountStatusChange(true, ids, 'status')
      } else if (command === 'closeAccount') {
        // 关闭账户
        this.accountStatusChange(false, ids, 'status')
      } else if (command === 'openMaterialAuth') {
        // 开启敏感物料授权
        this.changeSensitiveStatus(ids, 1)
      } else if (command === 'closeMaterialAuth') {
        // 关闭敏感物料授权
        this.changeSensitiveStatus(ids, 0)
      } else if (command === 'delAccount') {
        // 删除账户
        this.delAccount(ids)
      }
    },
    // 同步投放
    syncPut (type, id) {
      this.syncPutId = []
      if (type === 'batch') {
        if (this.listSelection.length < 1) {
          this.$message({
            message: '请选择需要同步的账户',
            type: 'warning'
          })
          return false
        } else {
          let arr = []
          this.listSelection.forEach((item, index) => {
            this.$set(arr, arr.length, item.id)
          })
          this.syncPutId = arr
        }
      } else {
        this.syncPutId = [id]
      }
      // console.log(this.syncPutId)
      if (this.syncPutId.length >= 1) {
        this.$service.post('/api/account/data/sync/oe/item', {
          'enterpriseAccountIds': this.syncPutId
        }).then(res => {
          this.$message({
            message: res.message,
            type: 'success'
          })
          this.getputInAccountManageList()
        }).catch(Err => {
        })
      }
    },
    // 同步数据（批量）
    syncData (batch, type, id, row) {
      if (batch) {
        if (this.listSelection.length < 1) {
          this.$message({
            message: '请选择需要同步的账户',
            type: 'warning'
          })
          return false
        }
      }
      this.syncDataId = []
      this.syncDataType = type
      if (type === 'syncAccountData') {
        this.pickerOptions = {
          disabledDate (time) {
            // return time.getTime() > Date.now() || time.getTime() < new Date(handleTimeMonthsAgo(new Date(), 2, true)).getTime()
            return time.getTime() > Date.now() || time.getTime() < new Date('2022-02-28').getTime()
          }
        }
        if (batch) {
          this.syncDataTitle = '批量同步数据'
          this.listSelection.forEach((item, index) => {
            this.syncDataId[index] = item.id
          })
        } else {
          this.syncDataTitle = '同步数据'
          this.syncDataId[0] = id
        }
      } else if (type === 'syncMaterialAuth') {
        if (row) {
          this.syncDataForm.optClue = row.optClue || 0
        }
        this.pickerOptions = {
          disabledDate (time) {
            return time.getTime() > Date.now() || time.getTime() < new Date(handleTimeMonthsAgo(new Date(), 3)).getTime()
          }
        }
        this.syncDataForm.filterDate = [new Date(handleTimeMonthsAgo(new Date(), 3)), new Date()]
        let thisStatus = false
        if (batch) {
          this.syncDataTitle = '批量同步飞鱼数据'
          let accountName = ''
          this.listSelection.forEach((item) => {
            if (!item.sensitiveStatus) {
              thisStatus = true
              if (accountName === '') {
                accountName += item.agentAccountName
              } else {
                accountName += '、' + item.agentAccountName
              }
            } else {
              this.$set(this.syncDataId, this.syncDataId.length, item.id)
            }
          })
          if (thisStatus) {
            this.$message({
              message: accountName + '未开启敏感物料授权，不能进行同步',
              type: 'warning'
            })
            return false
          }
        } else {
          this.syncDataTitle = '同步飞鱼数据'
          this.putInAccountManageList.forEach((item) => {
            if (item.id === id) {
              if (!item.sensitiveStatus) {
                thisStatus = true
              } else {
                this.syncDataId[0] = id
              }
            }
          })
          if (thisStatus) {
            this.$message({
              message: '敏感物料授权状态为关闭时不能进行同步',
              type: 'warning'
            })
            return false
          }
        }
      }
      console.log(this.syncDataId)
      this.syncDataVisible = true
    },
    syncDataSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {}
          // console.log(this.syncDataForm.filterDate)
          // console.log(this.syncDataId)
          if (this.syncDataType === 'syncAccountData') {
            // 同步数据
            param = {
              'beginTime': getTime(new Date(this.syncDataForm.filterDate[0])),
              'endTime': getTime(new Date(this.syncDataForm.filterDate[1])),
              'enterpriseAccountIds': this.syncDataId
            }
            this.btnLoading = true
            this.$service.post('/api/account/data/sync/oe/report', param).then(res => {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.getputInAccountManageList()
              this.btnLoading = false
              this.syncDataVisible = false
            }).catch(Err => {
              this.btnLoading = false
            })
          } else if (this.syncDataType === 'syncMaterialAuth') {
            // 同步飞鱼线索
            if (this.syncDataForm.optClue === 1) {
              // 二次确认提示
              this.$confirm('开启自动同步线索后，平台会每日自动同步前一日的飞鱼线索，是否确认开启？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  this.feiyuClue()
                })
                .catch(() => {})
            } else {
              // this.feiyuClue()
              this.feiyuClue()
            }
          }
          console.log(param)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    feiyuClue() {
      this.btnLoading = true
      // 同步飞鱼线索
      console.log('feiyuClue', this.syncDataId)
      const param = {
        optClue: this.syncDataForm.optClue,
        timeStart: getTime(new Date(this.syncDataForm.filterDate[0])),
        timeEnd: getTime(new Date(this.syncDataForm.filterDate[1])),
        accountId: this.syncDataId[0]
        // 'accountIdList': this.syncDataId
      }
      this.$service.post('/api/account/data/sync/oe/feiyuClue', param).then(res => {
        console.log(res)
        this.btnLoading = false
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.result.msg)
        }
        this.getputInAccountManageList()
        this.syncDataVisible = false
      }).catch(Err => {
        this.btnLoading = false
      })
    },

    // 保存选中结果
    handleSelectionChange (val) {
      this.listSelection = val
      let num = 0
      val.forEach(item => {
        if (!item.status) {
          num += 1
        }
      })
      if (num > 0) {
        this.listSelectionStatus = true
      } else {
        this.listSelectionStatus = false
      }
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.pagesize = size
      this.getputInAccountManageList()
    },
    // 切换分页
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getputInAccountManageList()
    },
    // 穿梭框回调
    transferLeftChange(value) {
      console.log(value)
    },
    handleChange (value, direction, movedKeys) {
      console.log(value)
      console.log(direction)
      console.log(movedKeys)
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  computed: {
    isQianchuan() {
      return this.$route.path.startsWith('/qianchuan')
    }
  }
}
</script>

<style lang="less">
  @import './../../styles/accountManage/putInAccountManage.less';
</style>



// WEBPACK FOOTER //
// src/views/accountManage/putInAccountManage.vue